import { WellnessAdd } from "../../features"

const WellnessAddPage = () => {
  return <WellnessAdd />
}

export default WellnessAddPage
